import { render } from "./AppGames.vue?vue&type=template&id=26cc36e0&scoped=true"
import script from "./AppGames.vue?vue&type=script&lang=js"
export * from "./AppGames.vue?vue&type=script&lang=js"

import "./AppGames.vue?vue&type=style&index=0&id=26cc36e0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cc36e0"]])

export default __exports__